import React, { useState } from 'react';

import {
  Collapse,
  Steps,
} from 'UI';
import { ProductionItem, ProductionItemDetail } from 'constants/interface';
import { ProductionItemStatusEnum } from 'constants/order';
import {
  DownOutlined,
  MoreOutlined,
  RightOutlined,
} from '@ant-design/icons';

import {
  ClickableStep,
  CollapseWrapper,
  MoreIconWrapper,
  StepCollapse,
  StepCollapsePanel,
} from './style';
import { SeedingProgress } from './components';

// import {
//   LoadingContainer,
//   MainContainer,
//   OrderDescriptions,
// } from './style';

interface ProgressProps {
  item: ProductionItemDetail
}

enum ProductionItemStepIndexEnum {
  SEEDING,
  PRODUCTION,
  DELIVERY,
  FINISHED,
}

const StatusToStepMapping: Record<
ProductionItemStatusEnum,
ProductionItemStepIndexEnum
> = {
  [ProductionItemStatusEnum.CONFIRMED]: -1,
  [ProductionItemStatusEnum.SEEDING]: ProductionItemStepIndexEnum.SEEDING,
  [ProductionItemStatusEnum.PRODUCTION]: ProductionItemStepIndexEnum.PRODUCTION,
  [ProductionItemStatusEnum.DELIVERY]: ProductionItemStepIndexEnum.DELIVERY,
  [ProductionItemStatusEnum.FINISHED]: ProductionItemStepIndexEnum.FINISHED,
};

const Progress = ({
  item,
}: ProgressProps): JSX.Element => {
  const [isSeedingVisible, setSeedingVisible] = useState(
    StatusToStepMapping[item.status].valueOf() === ProductionItemStepIndexEnum.SEEDING.valueOf(),
  );
  const [isProductionVisible, setProductionVisible] = useState(
    StatusToStepMapping[item.status].valueOf() === ProductionItemStepIndexEnum.PRODUCTION.valueOf(),
  );
  const [isDeliveryVisible, setDeliveryVisible] = useState(
    StatusToStepMapping[item.status].valueOf() === ProductionItemStepIndexEnum.DELIVERY.valueOf(),
  );

  const onStepClick = (cur: number) => {
    const actionMapper: Record<number, {
      curValue: boolean
      action: React.Dispatch<React.SetStateAction<boolean>>
    }> = {
      [ProductionItemStepIndexEnum.SEEDING]: {
        curValue: isSeedingVisible,
        action: setSeedingVisible,
      },
      [ProductionItemStepIndexEnum.PRODUCTION]: {
        curValue: isProductionVisible,
        action: setProductionVisible,
      },
      [ProductionItemStepIndexEnum.DELIVERY]: {
        curValue: isDeliveryVisible,
        action: setDeliveryVisible,
      },
    };

    actionMapper[cur]?.action(!actionMapper[cur]?.curValue);
  };

  const isSeedingDisabled = StatusToStepMapping[item.status].valueOf()
    < ProductionItemStepIndexEnum.SEEDING.valueOf();
  const isProductionDisabled = StatusToStepMapping[item.status].valueOf()
    < ProductionItemStepIndexEnum.PRODUCTION.valueOf();
  const isDeliveryDisabled = StatusToStepMapping[item.status].valueOf()
    < ProductionItemStepIndexEnum.DELIVERY.valueOf();

  return (
    <Steps
      direction="vertical"
      current={StatusToStepMapping[item.status]}
    >
      <ClickableStep
        title={(
          <div>
            {isSeedingVisible ? (<DownOutlined />) : (<RightOutlined />)}
            {' Semeio'}
          </div>
        )}
        onStepClick={onStepClick}
        disabled={isSeedingDisabled}
        description={(
          <CollapseWrapper
            onClick={(e) => e.stopPropagation()}
          >
            <StepCollapse
              ghost
              activeKey={
                isSeedingVisible
                  ? ProductionItemStatusEnum.SEEDING
                  : undefined
              }
            >
              <StepCollapsePanel
                key={ProductionItemStatusEnum.SEEDING}
                header={(
                  <MoreIconWrapper
                    isVisible={!isSeedingDisabled && !isSeedingVisible}
                  >
                    <MoreOutlined />
                  </MoreIconWrapper>
                )}
                showArrow={false}
              >
                <SeedingProgress item={item} />
              </StepCollapsePanel>
            </StepCollapse>
          </CollapseWrapper>
        )}
      />
      <ClickableStep
        title={(
          <div>
            {isProductionVisible ? (<DownOutlined />) : (<RightOutlined />)}
            {' Desenvolvimento'}
          </div>
        )}
        onStepClick={onStepClick}
        disabled={isProductionDisabled}
        description={(
          <CollapseWrapper
            onClick={(e) => e.stopPropagation()}
          >
            <Collapse
              ghost
              activeKey={
                isProductionVisible
                  ? ProductionItemStatusEnum.PRODUCTION
                  : undefined
              }
            >
              <Collapse.Panel
                key={ProductionItemStatusEnum.PRODUCTION}
                header={(
                  <MoreIconWrapper
                    isVisible={!isProductionDisabled && !isProductionVisible}
                  >
                    <MoreOutlined />
                  </MoreIconWrapper>
                )}
                showArrow={false}
              >
                Hello There Production
              </Collapse.Panel>
            </Collapse>
          </CollapseWrapper>
        )}
      />
      <ClickableStep
        title={(
          <div>
            {isDeliveryVisible ? (<DownOutlined />) : (<RightOutlined />)}
            {' Entrega'}
          </div>
        )}
        onStepClick={onStepClick}
        disabled={isDeliveryDisabled}
        description={(
          <CollapseWrapper
            onClick={(e) => e.stopPropagation()}
          >
            <Collapse
              ghost
              activeKey={
                isDeliveryVisible
                  ? ProductionItemStatusEnum.DELIVERY
                  : undefined
              }
            >
              <Collapse.Panel
                key={ProductionItemStatusEnum.DELIVERY}
                header={(
                  <MoreIconWrapper
                    isVisible={!isDeliveryDisabled && !isDeliveryVisible}
                  >
                    <MoreOutlined />
                  </MoreIconWrapper>
                )}
                showArrow={false}
              >
                Hello There Delivery
              </Collapse.Panel>
            </Collapse>
          </CollapseWrapper>
        )}
      />
    </Steps>
  );
};

export default Progress;
